// extracted by mini-css-extract-plugin
module.exports =  {"trigger":"yvFG0X6","full-width":"SPA44W7","fullWidth":"SPA44W7"};